<div style=" display: inline;block-size: 10%;">
  <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite padHeder" style="padding-right: 0px;">
    <div class="col-md-6" style="display: inline-block; padding-left: 0px;">
      <h2 class="ng-binding header">
        Purchase Order History
      </h2>
    </div>
    <div class="col-md-6" style="display: inline-block; padding-right: 0px; position:relative;padding-top: 6PX;">
      <span class="btn-blue" style="font-size: 13px; display: inline-block; padding: 4px 12px 4px; font-size: 15px; margin-left: 10px; float: right;" (click)="backBtn()">
        <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
      </span>
      <span class="btn btn-yellow fntSz excelbtn" (click)="exportToExcel()" title="Export to Excel"
        style="cursor:pointer;margin-left: 10px;line-height: 23px; float: right;padding: 5px 11px;"><span><i
        class="fa fa-file-excel-o" aria-hidden="true" style="font-size: 13px;"></i></span></span>
    </div>
  </div>
</div>

<div class="col-md-3 col-xs-3 col-sm-3 pad15" style="display: inline-block; margin-top: 27px;">
  <select required="" class="mrgnLeft10 form-control " style="width:135px;margin-left:0px;width: 90%;"
    placeholder="Select Supplier">
    <option value="0" disabled="" selected="" hidden="">Select Supplier</option>
    <option id="select" value="2" class="ng-binding ng-scope">Electronics</option>
    <option id="select" value="3" class="ng-binding ng-scope">Eng.</option>
    <option id="select" value="4" class="ng-binding ng-scope">Food</option>
    <option id="select" value="5" class="ng-binding ng-scope">Furniture</option>
  </select>
</div>

<div class="col-md-3 col-xs-3 col-sm-3 pad15 " style="display: inline-block;">
  <select required="" class="mrgnLeft10 form-control " style="width:135px;margin-left:0px;width: 90%;"
    placeholder="Select Category">
    <option value="0" disabled="" selected="" hidden="">Select Category</option>
    <option id="select" value="2" class="ng-binding ng-scope">Electronics</option>
    <option id="select" value="3" class="ng-binding ng-scope">Eng.</option>
    <option id="select" value="4" class="ng-binding ng-scope">Food</option>
    <option id="select" value="5" class="ng-binding ng-scope">Furniture</option>
  </select>
</div>

<div class="col-md-3 col-xs-3 col-sm-3 pad15" style="display: inline-block;">
  <!-- <label>Month:</label> -->

  <select required="" class="mrgnLeft10 form-control "
    style="width:135px;margin-left:0px;width:80%;display: inline-block;" placeholder="Select Category">

    <option value="0" disabled="" selected="" hidden="">Select Month</option>
    <option id="select" value="2" class="ng-binding ng-scope">June 2012</option>
    <option id="select" value="3" class="ng-binding ng-scope">May 2019</option>
    <option id="select" value="4" class="ng-binding ng-scope">Jan 2020</option>
    <option id="select" value="5" class="ng-binding ng-scope">June 2022</option>
  </select>
</div>

<div class="col-md-3 col-3 col-sm-3 pad0 bgWhite "
  style="display: inline-block;padding-right: 0px;position: relative;left: 16%;">
  <span _ngcontent-ceh-c1="" class="btn btn-yellow fntSz searchbtn">
    <span _ngcontent-ceh-c1="" style="margin-right: 5px; "><i _ngcontent-ceh-c1="" aria-hidden="true"
        class="fa fa-search" style="font-size: 16px;position: relative;top: 1px; "></i>
    </span><span _ngcontent-ceh-c1="">Search</span>
  </span>
</div>

<div class="col-md-6 col-12 col-sm-12 pad0 bgWhite color ">
  <span class="label orangeBadge fntSz {{filter == 0 ? 'activeOrange' : ''}}" (click)="typeFilter(0)"
    style="cursor:pointer;margin-left:0px;"><span>All</span></span>
  <span class="label yellowBadge fntSz {{filter == 1 ? 'activeYellow' : ''}}" (click)="typeFilter(1)"
    style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
        aria-hidden="true"></i></span> <span>Completed</span></span>
  <span class="label greenBadge fntSz {{filter == 2 ? 'activeGreen' : ''}}" (click)="typeFilter(2)"
    style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
        aria-hidden="true"></i></span> <span>Short Closed</span></span>
  <span class="label blueBadge fntSz {{filter == 3 ? 'activeBlue' : ''}}" (click)="typeFilter(3)"
    style="cursor:pointer;margin-left:5px;"><span style="margin-right:5px"><i class="fa fa-square"
        aria-hidden="true"></i></span> <span>Cancelled</span></span>
</div>

<div class="wrapper" style="overflow: hidden; text-overflow: ellipsis; padding-top: 20px;">
  <table mat-table [dataSource]="dataSource" style="margin-top:20px">
    <ng-container matColumnDef="orderno">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label>Order No.</label>
      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element"> {{element.orderno}} </td>
    </ng-container>

    <ng-container matColumnDef="item">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label> Item</label>
      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element"> {{element.item}} </td>
    </ng-container>

    <ng-container matColumnDef="supplier">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label>Supplier</label>
      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element"> {{element.supplier}} </td>
    </ng-container>

    <ng-container matColumnDef="rate">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label>Rate</label>
      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.rate}} </td>
    </ng-container>

    <ng-container matColumnDef="ordqty">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label>Ord. Qty</label>
      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.ordqty}} </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label>Amt.</label>
      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.amount}} </td>
    </ng-container>

    <ng-container matColumnDef="inwqty">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label>inw. Qty</label>
      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.inwqty}} </td>
    </ng-container>

    <ng-container matColumnDef="unit">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label>Unit</label>
      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element"> {{element.unit}} </td>
    </ng-container>

    <ng-container matColumnDef="orddate">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label>Ord. Dt</label>
      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element"> {{element.orddate}} </td>
    </ng-container>

    <ng-container matColumnDef="duedate">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label> Due Dt </label>
      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element"> {{element.duedate }} </td>
    </ng-container>

    <ng-container matColumnDef="inwdate">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label> Inw. Dt </label>
      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element"> {{element.inwdate }} </td>
    </ng-container>

    <ng-container matColumnDef="invdate">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label> Inv. Dt </label>
      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element"> {{element.invdate }} </td>
    </ng-container>

    <ng-container matColumnDef="grnno">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label> GRN NO.</label>
      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.grnno}} </td>
    </ng-container>

    <ng-container matColumnDef="rating">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label> Rating </label>
      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.rating}} </td>
    </ng-container>

    <ng-container matColumnDef="punctuality">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>
        <label> Punctuality </label>
      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.punctuality}} </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>

      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element"> <i style="color: rgb(227 13 13); cursor: pointer; margin: 5px;"
          class="fa fa-ban" title="Status"></i>
      </td>
    </ng-container>

    <ng-container matColumnDef="notes">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>

      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element"> <i style="color:#E1A730; cursor: pointer; margin: 5px;"
          class="fa fa-sticky-note" title="Notes"></i>
      </td>
    </ng-container>

    <ng-container matColumnDef="po">
      <th class="header header-Table" mat-header-cell *matHeaderCellDef>

      </th>
      <td><input type="text"></td>
      <td mat-cell *matCellDef="let element"> <i style="color: blue; cursor: pointer; margin: 5px;" class="fa fa-print"
          title="Print"></i> </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <!-- Angular 8 pagination -->
  <mat-paginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
  </mat-paginator>

  <div class="col-md-12 col-xs-12 col-sm-12">
    <h6>Total Value : </h6>
  </div>
</div>